module.exports = __webpack_public_path__ + "img/facial_hair_moustache_thin.848855b4.png";